module.exports = __webpack_public_path__ + "img/2.58306690.svg";